import { languageMap } from ".."

languageMap.cobol = {
	comments: {
		line: "*",
	},
}
